import { useMutation } from '@apollo/client'
import { GENERATE_MEDICARE_PRESIGNED_URL } from 'apollo/queries'
import axios from 'axios'

export const useMedicareDocumentsUpload = () => {
  const [generateFileUrl] = useMutation(GENERATE_MEDICARE_PRESIGNED_URL, {
    fetchPolicy: 'no-cache',
  })

  const uploadFile = async (url: string, file) => {
    await axios.put(url, file, {
      transformRequest: [
        (data, headers) => {
          delete headers.Authorization
          return data
        },
      ],
    })
  }

  return {
    generateFileUrl,
    uploadFile,
  }
}
